import qs from 'qs';

export const buildRequestUrl = (
  url: string,
  params?: Record<string, unknown>,
  method?: string,
): string => {
  if (params && method === 'GET') {
    const queryString = qs.stringify(params, {
      encodeValuesOnly: true,
      skipNulls: true,
    });
    return `${url}?${queryString}`;
  }
  return url;
};
